// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Eye Move Investment",
    image: logoCT,
    route: "/",
  },
  menus: [
    {
      name: "business info",
      items: [
        { name: "EYE MOVE INVESTMENT (PTY) LTD", route: "/" },
        { name: "Company registration: 2018 / 641896 / 07", route: "/" },
        { name: "VAT Number: 4440306498", route: "/" },
      ],
    },
    {
      name: "company",
      items: [
        { name: "about us", route: "#about-us" },
        { name: "our services", route: "#what-we-do" },
        { name: "our suppliers", route: "#our-suppliers" },
        { name: "sectors we serve", route: "#sectors" },
      ],
    },
    {
      name: "help & support",
      items: [{ name: "contact us", route: "#contact-us" }],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography
        component="a"
        href="https://www.eyemoveinvestment.co.za"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Eye Move Investment
      </MKTypography>
      .
    </MKTypography>
  ),
};
